/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

@Component({
    template: require('./tanques.component.html')
})
export class TanquesComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/tanques.component.ts
 **/